export const architecturePages = [
  {
    slug: 'innovventures',
    name: 'InnovVentures',
    navLabel: 'InnovVentures',
    group: 'capability',
    category: 'Venture Studio',
    headline: 'From possibility to enterprise',
    summary:
      'InnovVentures is the venture studio arm, where opportunities are identified, concepts are shaped and new businesses are built.',
    seoTitle: 'InnovVentures | Venture Studio',
    seoDescription:
      'InnovVentures is InnovHer\'s venture studio arm, hands-on across strategy, product, business models, validation, partnerships, technology and go-to-market.',
    keywords:
      'InnovVentures, Venture Studio InnovHer, venture studio India, co-build startups, enCODE, BAX, Bharat Ventures, CTPL, i2i',
    intro: [
      'InnovVentures is the venture studio arm, where opportunities are identified, concepts are shaped and new businesses are built.',
      'The studio works hands-on across venture strategy, product development, business models, market validation, partnerships, technology and go-to-market, bringing together the capabilities required to move an idea towards an investable and scalable enterprise.',
      'Some ventures originate within the InnovHer ecosystem; others are built alongside founders, institutions and strategic partners.',
      'The approach goes beyond advising businesses from the outside. InnovVentures participates in the building journey, creating, validating and strengthening ventures from within.',
    ],
    statement: {
      title: 'From possibility to enterprise',
      text: 'Creating, validating and strengthening ventures from within, not advising from the outside.',
    },
    blocks: [
      {
        title: 'What the studio covers',
        items: [
          { title: 'Venture strategy', text: 'Shape the opportunity and the path to an investable enterprise.' },
          { title: 'Product & business models', text: 'Build the offer and the model that can scale.' },
          { title: 'Market validation', text: 'Test demand before the venture hardens around the wrong assumption.' },
          { title: 'Partnerships, technology & GTM', text: 'Bring the capabilities required to reach market and scale.' },
        ],
      },
      {
        title: 'Ongoing builds',
        items: [
          { title: 'EnCODE', text: 'Active studio build within the InnovHer ecosystem.' },
          { title: 'Ctpl.Online', text: 'Active studio build within the InnovHer ecosystem.' },
          { title: 'BaX', text: 'Beyond Ability X, active studio build.' },
          { title: 'i2i connect', text: 'Active studio build within the InnovHer ecosystem.' },
        ],
      },
    ],
    close: {
      title: 'Build with InnovVentures',
      text: 'Whether the venture starts inside InnovHer or alongside founders and partners, the studio stays in the build.',
      line: 'From possibility to enterprise.',
    },
    cta: { label: 'Contact InnovHer', to: '/contact' },
  },
  {
    slug: 'innovace',
    name: 'InnovAce',
    navLabel: 'InnovAce',
    group: 'capability',
    category: 'Accelerator',
    headline: 'Accelerating ambition into scale',
    summary:
      'InnovACE is an accelerator for founders and ventures ready to move from potential to measurable growth.',
    seoTitle: 'InnovACE, Accelerating Ambition into Scale',
    seoDescription:
      'An intensive 18-month accelerator combining strategic guidance, founder capability, market access, mentorship and investment readiness inside the InnovHer ecosystem.',
    keywords:
      'InnovACE, InnovAce accelerator, startup accelerator India, 18 month accelerator, InnovHer portfolio',
    intro: [
      'InnovACE is an accelerator for founders and ventures ready to move from potential to measurable growth.',
      'Built around an intensive 18-month journey, InnovACE combines strategic guidance, founder capability, market access, mentorship, business networks, investment readiness and opportunities for capital and collaboration.',
      'Rather than following a one-size-fits-all accelerator model, each venture progresses against its own priorities, milestones and growth trajectory, supported by the wider InnovHer ecosystem.',
      'With a growing portfolio of ventures and alumni, InnovACE is designed around one central objective, help promising businesses become stronger, more resilient and ready for their next stage.',
    ],
    statement: {
      title: 'Accelerating ambition into scale',
      text: 'Not one-size-fits-all, each venture advances on its own priorities, milestones and growth trajectory.',
    },
    blocks: [
      {
        title: 'What the journey includes',
        items: [
          { title: 'Strategic guidance', text: 'Direction aligned to the venture’s stage and ambitions.' },
          { title: 'Founder capability', text: 'Strengthen the people building the business.' },
          { title: 'Market access & networks', text: 'Open doors across customers, partners and peers.' },
          { title: 'Investment readiness', text: 'Prepare for capital and collaboration opportunities.' },
        ],
      },
    ],
    close: {
      title: 'Apply to InnovACE',
      text: 'Join founders and ventures ready to move from potential to measurable growth.',
      line: 'Accelerating ambition into scale.',
    },
    cta: { label: 'Apply to InnovAce', to: '/apply' },
  },
  {
    slug: 'innoveda',
    name: 'InnovVeda.ai',
    navLabel: 'InnovVeda.ai',
    group: 'capability',
    category: 'Technology & AI',
    headline: 'Technology to scale and expand horizons',
    summary:
      'InnovVeda.ai is technology and AI development team, enabling ventures to translate business ideas into intelligent, scalable digital products and infrastructure.',
    seoTitle: 'InnovVeda.ai, Technology to Scale and Expand Horizons',
    seoDescription:
      'InnovVeda.ai approaches technology through business outcomes, product architecture, platforms, AI, automation and data systems for ventures.',
    keywords:
      'InnovVeda.ai, AI development, venture technology, product architecture, InnovHer technology',
    intro: [
      'InnovVeda.ai is technology and AI development team, enabling ventures to translate business ideas into intelligent, scalable digital products and infrastructure.',
      'From product architecture and platform development to AI integration, automation, data systems and emerging technologies, InnovVeda.ai approaches technology through the lens of business outcomes rather than technology alone.',
      'Working alongside founders and InnovHer’s venture-building platforms, it helps determine what should be built, why it matters and how technology can create meaningful advantage.',
      'The ambition is simple: make technology a strategic capability of the venture, not merely a service supporting it.',
    ],
    statement: {
      title: 'Technology as a strategic capability',
      text: 'Business outcomes first, what should be built, why it matters, and how technology creates advantage.',
    },
    blocks: [
      {
        title: 'What the work covers',
        items: [
          { title: 'Product architecture', text: 'Shape digital products that can scale with the venture.' },
          { title: 'Platform development', text: 'Build infrastructure ventures can grow on.' },
          { title: 'AI & automation', text: 'Integrate intelligence where it creates meaningful advantage.' },
          { title: 'Data systems', text: 'Systems that turn information into operating leverage.' },
        ],
      },
    ],
    close: {
      title: 'Visit InnovVeda.ai',
      text: 'Explore the full technology practice on the InnovVeda website, or start a conversation with InnovHer.',
      line: 'Technology to scale and expand horizons.',
    },
    cta: { label: 'Visit InnovVeda.ai', to: 'https://innoveda.ai', external: true },
  },
  {
    slug: 'innovpulse',
    name: 'InnovPulse',
    navLabel: 'InnovPulse',
    group: 'infrastructure',
    category: 'Operating & performance system',
    headline: 'One System. One View. Better Execution.',
    summary: 'An integrated operating and performance system that connects organisational priorities, ownership, execution and performance in one structured framework.',
    seoTitle: 'InnovPulse, Organisational Operating & Performance System',
    seoDescription: 'InnovPulse is an integrated operating and performance system that connects organisational priorities, ownership, execution and performance in one structured framework.',
    keywords: 'InnovPulse, operating system, performance management, organisational clarity, InnovHer, KPI, execution tracking',
    intro: [
      'InnovPulse is an integrated operating and performance system that connects organisational priorities, ownership, execution and performance in one structured framework.',
      'It gives teams and leadership a unified view of how work moves across functions, so alignment, accountability and delivery stay clear as the organisation grows.',
    ],
    blocks: [
      {
        title: 'What InnovPulse enables',
        items: [
          { title: 'Priority & performance clarity', text: 'Connect personal and team goals with clear progress and performance visibility.' },
          { title: 'Execution tracking', text: 'Follow key actions, priorities and deliverables across functions through a structured operating rhythm.' },
          { title: 'Cross-functional alignment', text: 'Create visibility across interdependent teams so shared priorities move forward with clear ownership.' },
          { title: 'Organisational visibility', text: 'Give leadership and teams a consolidated view of execution, progress and performance across the organisation.' },
          { title: 'Accountability & ownership', text: 'Make responsibilities, priorities and deliverables easy to assign, track and follow through.' },
          { title: 'Structured reviews', text: 'Support consistent performance and progress reviews with a shared view of outcomes, not fragmented updates.' },
        ],
      },
    ],
    close: {
      title: 'One System. One View. Better Execution.',
      text: 'InnovPulse acts as a central operating layer, bringing clarity to how priorities are set, owned, executed and reviewed across the organisation.',
      line: 'Align. Execute. Measure. Improve.',
    },
    cta: { label: 'Explore InnovPulse', to: '/innovpulse' },
  },
  {
    slug: 'studio-i',
    name: 'Studio-I',
    navLabel: 'Studio-I',
    group: 'infrastructure',
    category: 'Collaborative workspace',
    headline: 'Where Ideas, People and Businesses Come Together',
    summary: 'InnovHer’s collaborative workspace and startup ecosystem hub for founders, professionals, mentors, investors and growing teams.',
    seoTitle: 'Studio-I | Where Ideas, People and Businesses Come Together',
    seoDescription: 'Studio-I is InnovHer\'s collaborative workspace and startup ecosystem hub for founders, professionals, mentors, investors and growing teams in Jaipur.',
    keywords: 'Studio-I, Studio i Jaipur, InnovHer workspace, startup ecosystem hub, founder coworking Jaipur',
    gallery: true,
    intro: [
      'Studio-I is InnovHer’s collaborative workspace and startup ecosystem hub, designed for founders, professionals, mentors, investors and growing teams to work, meet and build within an active business environment.',
      'More than a workspace, Studio-I brings together the infrastructure, people and ecosystem access that early-stage and growing businesses need to move forward.',
    ],
    statement: {
      title: 'Work here. Meet here. Build here. Grow here.',
      text: 'A professional space designed around the realities of building a business.',
    },
    blocks: [
      {
        title: 'More than a workspace',
        items: [
          { title: 'Work', text: 'A professional environment for founders, startups and teams to operate and build.' },
          { title: 'Connect', text: 'Meet entrepreneurs, mentors, professionals, investors and ecosystem stakeholders.' },
          { title: 'Collaborate', text: 'Partnerships, business development, knowledge exchange and cross-ecosystem collaboration.' },
          { title: 'Learn', text: 'Interactions, discussions, expert sessions and community-led learning.' },
          { title: 'Grow', text: 'Stay connected with InnovHer’s broader ecosystem of acceleration, mentorship and investor networks.' },
        ],
      },
    ],
    close: {
      title: 'Become Part of Studio-I',
      text: 'Looking for a professional workspace surrounded by an active startup ecosystem? Connect with InnovHer to explore Studio-I.',
      line: 'Work here. Meet here. Build here. Grow here.',
    },
    cta: { label: 'Explore Studio-I', to: '/studio-i' },
  },
  {
    slug: 'issi',
    name: 'iSSi',
    navLabel: 'iSSi',
    group: 'infrastructure',
    category: 'Startup support initiative',
    headline: 'Because innovation needs a society that shows up',
    summary: 'InnovHer’s commitment to nurturing the environment around entrepreneurship through recurring formats, open conversations and curated experiences.',
    seoTitle: 'iSSi | Because Innovation Needs a Society That Shows Up',
    seoDescription: 'iSSi, InnovHer Startup Support Initiative, nurtures entrepreneurship through Founders\' Night, Enablers Engage, Fish Tank, Rajasthan Startup Stories and publications.',
    keywords: 'iSSi, InnovHer Startup Support Initiative, Founders Night, Enablers Engage, Fish Tank, Rajasthan Startup Stories, Jaipur',
    intro: [
      'Innovation begins with individual ambition, but rarely grows in isolation. It needs curiosity, conversations, validation, encouragement and a community willing to participate in the journey.',
      'iSSi, InnovHer Startup Support Initiative, is InnovHer’s commitment to nurturing the environment around entrepreneurship. Through recurring formats, open conversations and curated experiences, iSSi brings founders closer to business leaders, enablers, investors, young minds and the wider community.',
    ],
    blocks: [
      {
        title: 'Signature iSSi formats',
        items: [
          { title: "Founders' Night", text: 'When the world sleeps, founders build. An after-hours gathering at Studio I for candid conversations and community.' },
          { title: 'Enablers Engage', text: 'Deep conversations and strategic connections through focused sector roundtables with experts, businesses and investors.' },
          { title: 'Fish Tank', text: 'Pitch. Question. Validate. Founders test assumptions before an engaged audience, not simply to raise capital.' },
          { title: 'Rajasthan Startup Stories', text: 'A podcast documenting founders, businesses and ecosystem builders shaping entrepreneurship across Rajasthan.' },
        ],
      },
    ],
    close: {
      title: 'Show up for the builders',
      text: 'Make innovation more visible, conversations more meaningful and entrepreneurship more participative.',
      line: 'Because innovation needs a society that shows up.',
    },
    cta: { label: 'Explore iSSi', to: '/issi' },
  },
];

export function pagePath(company) {
  const prefix = company.group === 'capability'
    ? '/capabilities'
    : company.group === 'infrastructure'
      ? '/infrastructure'
      : '/ventures';
  return `${prefix}/${company.slug}`;
}
